import { CIcon } from '~/icons/types'
export const ciBicycleFrameLowstep: CIcon = {
  width: 24,
  height: 24,
  paths: [
    {
      d:
        'M9.497 15.07a4.34 4.34 0 1 1-5.59-4.64 3.21 3.21 0 0 0-1.73-1.19.49.49 0 0 1-.37-.43l-.02-.25a.508.508 0 0 1 .12-.39.523.523 0 0 1 .37-.16h5.97l.11.25a.525.525 0 0 0-.1.11l-.39.64h-3.97a4.48 4.48 0 0 1 1.1 1.23 1.21 1.21 0 0 1 .19-.01 4.478 4.478 0 0 1 1.72.35l-.53.87a2.957 2.957 0 0 0-.89-.2 5.045 5.045 0 0 1 .28 1.19l-.98 1.61a5.387 5.387 0 0 0-.35-2.73 3.333 3.333 0 1 0 4.05 3.75Z',
      class: 'secondary'
    },
    {
      d:
        'm7.777 11.09-.53.86a3.289 3.289 0 0 1 1.24 2.12h1.01a4.356 4.356 0 0 0-1.72-2.98Z',
      class: 'secondary'
    },
    {
      d:
        'M19.337 7.37a2.567 2.567 0 0 0-1.78.18 4.344 4.344 0 0 0-.64.33c-.08.05-.17.11-.25.16a6.915 6.915 0 0 0-2.22 2.61c-.16.33-.29.68-.42 1.03-.09.23-.18.47-.28.7a3.295 3.295 0 0 1-.88 1.32.767.767 0 0 1-.11.08 1.297 1.297 0 0 0-1.19-.76c-.02 0-.03 0-.04.01h-.01L9.157 7.6l-1.09-.01.18.42.11.25a.525.525 0 0 0-.1.11l-.39.64-.96 1.57-.53.87-.61.99-.98 1.61-.16.26a.475.475 0 0 0-.01.5.493.493 0 0 0 .43.26h5.42a1.314 1.314 0 0 0 2.29-.15 3.049 3.049 0 0 0 .75-.45 4.417 4.417 0 0 0 1.16-1.7c.11-.24.2-.49.29-.74.13-.32.25-.64.39-.95a5.815 5.815 0 0 1 1.67-2.05 4.143 4.143 0 0 1 .43-.3 3.623 3.623 0 0 1 .44-.24 1.726 1.726 0 0 1 1.17-.16.504.504 0 0 0 .62-.34.497.497 0 0 0-.34-.62Zm-9.06 6.7h-4.33l1.3-2.12.53-.86 1.06-1.73 1.77 4.08a1.322 1.322 0 0 0-.33.63Zm1.01 0a.441.441 0 0 1 .32-.02.632.632 0 0 1 .07.02Z',
      class: 'main'
    },
    {
      d: 'M11.677 14.07h-.39a.441.441 0 0 1 .32-.02.632.632 0 0 1 .07.02Z',
      class: 'main'
    },
    {
      d:
        'M17.557 7.55a4.344 4.344 0 0 0-.64.33c-.08.05-.17.11-.25.16l-.62-1.75-1.77-.2a.497.497 0 0 1-.44-.55.502.502 0 0 1 .55-.44l2.08.22c.01 0 .01 0 .02.01a.014.014 0 0 1 .02 0 .295.295 0 0 1 .13.05.301.301 0 0 1 .14.11.255.255 0 0 1 .08.12.076.076 0 0 1 .02.05.035.035 0 0 1 .01.02ZM19.527 10.23a3.988 3.988 0 0 0-.98.12l-.66-1.86a3.623 3.623 0 0 0-.44.24 4.143 4.143 0 0 0-.43.3l.59 1.65a4.336 4.336 0 1 0 1.92-.45Zm0 7.67a3.332 3.332 0 0 1-1.58-6.27l1.11 3.11a.496.496 0 0 0 .47.33.507.507 0 0 0 .17-.03.5.5 0 0 0 .3-.64l-1.11-3.1a2.73 2.73 0 0 1 .64-.07 3.335 3.335 0 1 1 0 6.67Z',
      class: 'secondary'
    },
    {
      d:
        'M10.227 7.1a.495.495 0 0 1-.5.5h-.57l-1.09-.01h-.66a.5.5 0 0 1 0-1h.01l2.32.01a.493.493 0 0 1 .49.5ZM11.677 14.07h-.39a.441.441 0 0 1 .32-.02.632.632 0 0 1 .07.02Z',
      class: 'main'
    },
    {
      d: 'M11.677 14.07h-.39a.441.441 0 0 1 .32-.02.632.632 0 0 1 .07.02Z',
      class: 'main'
    }
  ],
  name: 'bicycle-frame-lowstep',
  type: 'solid'
}
